export default "__VITE_ASSET__HuHNGPTE__"